import React, { useEffect, useRef, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

// import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { ContentDetailsStatusHistoryTableRow } from "../components";
import TableHeadComponent from "../../../../../common/TableHeadComponent";
import {
  StatusHistoryTableHeadCells,
  getComparator,
  stableSort,
} from "../../../../../constants";

export default function ContentDetailsStatusHistoryTable({ statusHistory }) {
  const scrollbarsRef = useRef(null);

  const [statusHistoryData, setStatusHistoryData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("date");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    setStatusHistoryData(
      stableSort(
        statusHistory,
        getComparator(order, orderBy)
      )
    );
  }, [order, orderBy, statusHistory]);

  return (
    <Box sx={mainBoxContainerStyles}>
      <Scrollbars
        style={scrollbar}
        autoHide={true}
        ref={scrollbarsRef} // Assign the ref to Scrollbars instance
        renderThumbVertical={({ style, ...props }) => (
          <div
            {...props}
            style={{
              ...style,
              ...scrollbarprops,
            }}
          />
        )}
      >
        <Paper sx={tablePaperContainerStyles}>
          <TableContainer
            sx={{ maxHeight: 300 }}
            style={{ border: "none", boxShadow: "none" }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHeadComponent
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                detailsPageReports={true}
                TableHeadData={StatusHistoryTableHeadCells}
              />
              {/* <ContentDetailsStatusHistoryTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              /> */}
              <TableBody>
                {statusHistoryData.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  const numberType = index % 2 == 0;

                  return (
                    <ContentDetailsStatusHistoryTableRow
                      row={row}
                      numberType={numberType}
                      labelId={labelId}
                      key={index}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Scrollbars>
    </Box>
  );
}

const mainBoxContainerStyles = {
  width: "100%",
  paddingRight: 1,
  border: "none",
  boxShadow: "none",
  marginTop: 3,
  marginBottom: 5,
};

const tablePaperContainerStyles = {
  maxWidth: "100%",
  mb: 2,
  border: "none",
  boxShadow: "none",
  overflow: "hidden",
};

const scrollbar = { maxWidth: "100%", height: "300px", marginLeft: "auto" };
const scrollbarprops = {
  width: "4px",
  backgroundColor: "#00A7CD",
  borderRadius: "2px",
};
